"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _TimelineFavoriteEventsOverrideStore = _interopRequireDefault(require("crm_ui/timeline/data/stores/TimelineFavoriteEventsOverrideStore"));

var _ImmutableModel = require("customer-data-objects/model/ImmutableModel");

var TimelineOverrideFavoriteEventDependency = {
  stores: [_TimelineFavoriteEventsOverrideStore.default],
  deref: function deref(_ref) {
    var objectType = _ref.objectType,
        subject = _ref.subject;

    if (subject && !objectType) {
      objectType = (0, _ImmutableModel.getObjectType)(subject);
    }

    return _TimelineFavoriteEventsOverrideStore.default.get(objectType);
  }
};
var _default = TimelineOverrideFavoriteEventDependency;
exports.default = _default;
module.exports = exports.default;